import { render, staticRenderFns } from "./InlineSvg.vue?vue&type=template&id=3bac5a44&scoped=true"
import script from "./InlineSvg.vue?vue&type=script&lang=js"
export * from "./InlineSvg.vue?vue&type=script&lang=js"
import style0 from "./InlineSvg.vue?vue&type=style&index=0&id=3bac5a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac5a44",
  null
  
)

export default component.exports